<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-27 16:19:44
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-07-01 17:10:38
 * @Description: 官网首页
 -->

<template>
  <div class="lender-edu-wrapper">
    <img src="https://files.jinr.com/jinr-index/img/lender-edu-01.png" alt="" srcset="" />
    <img src="https://files.jinr.com/jinr-index/img/lender-edu-02.png" alt="" srcset="" />
    <img src="https://files.jinr.com/jinr-index/img/lender-edu-03.png" alt="" srcset="" />
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scope>
.lender-edu-wrapper {
  img {
    display: block;
    width: 100%;
  }
}
</style>
